import React, { useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import Link from 'fe-design-base/molecules/Link';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx, cxEl } = cxHelpers('UpdateTaxClassificationWarnings');

import { SCROLL_KEYS } from 'features/payroll/constants';

const UpdateTaxClassificationWarnings = ({
  user,
  onClick,
  hasITIN,
  hasNoActivePayments,
}) => {
  const fullname = useCallback(
    () => `${user?.get('first_name')} ${user?.get('last_name')}`,
    [user]
  );
  const hasPendingPayrollRuns = !hasNoActivePayments;

  if (!user) return null;

  return (
    <Box className={cx()}>
      {hasPendingPayrollRuns && (
        <Box mt8 mb={24} data-testid={cxEl('HasPendingPayrollRuns')}>
          <Alert variant="error">
            <Box mr={4}>
              <Text variant="body" color="mono900">
                {toI18n(
                  'edit_team.individual_drawer.has_pending_payroll_run.prefix',
                  { props: { fullname: fullname() } }
                )}
                &nbsp;
                <Link
                  {...(onClick
                    ? { onClick }
                    : {
                        href: `/payroll?${SCROLL_KEYS.payrollHistory.queryParam}=1`,
                      })}
                >
                  {toI18n(
                    'edit_team.individual_drawer.has_pending_payroll_run.link'
                  )}
                </Link>
                &nbsp;
                {toI18n(
                  'edit_team.individual_drawer.has_pending_payroll_run.suffix'
                )}
              </Text>
            </Box>
          </Alert>
        </Box>
      )}
      {hasNoActivePayments && hasITIN && (
        <Box mt8 mb={24} data-testid={cxEl('HasITIN')}>
          <Alert variant="error">
            <Box mr={4}>
              <Text variant="body" color="mono900">
                {toI18n('edit_team.individual_drawer.has_an_itin.prefix', {
                  props: { fullname: fullname() },
                })}
                &nbsp;
                <Link href={`/team/${user?.get('id')}/personal_information`}>
                  {toI18n('edit_team.individual_drawer.has_an_itin.link')}
                </Link>
                &nbsp;
                {toI18n('edit_team.individual_drawer.has_an_itin.suffix')}
              </Text>
            </Box>
          </Alert>
        </Box>
      )}
    </Box>
  );
};

UpdateTaxClassificationWarnings.propTypes = {
  onClick: PropTypes.func,
  hasITIN: PropTypes.bool,
  user: ImmutablePropTypes.map,
  hasNoActivePayments: PropTypes.bool,
};

export default UpdateTaxClassificationWarnings;
